import useHotfiltersToDisplay from '@hooks/filters/use-hotfilters-to-display';
import React, { useMemo } from 'react';
import { useContextSelector } from 'use-context-selector';
import { CatalogContext } from '@context/catalog.context';
import SizeHotfilterAccordion from '@components/catalog/catalog-hotfilters/catalog-size-hotfilter/size-hotfilter-accordion/size-hotfilter-accordion';
import { sizeHotfilterGroupConfigurations } from '@config/catalog/hotfilter-group-configurations';
import MysizesWrapper from '@components/organisms/catalog/components/filter-content/mysizes-wrapper';
import styles from './catalog-size-hotfilter.module.scss';

const CatalogSizeHotfilter = () => {
  const { filterGroupsToDisplay } = useHotfiltersToDisplay(sizeHotfilterGroupConfigurations);
  const facetsOrder = useContextSelector(CatalogContext, (v) => v.facetsOrder);

  const orderedFilterGroups = useMemo(
    () => [...filterGroupsToDisplay].sort((a, b) => facetsOrder.indexOf(a.facet) - facetsOrder.indexOf(b.facet)),
    [facetsOrder, filterGroupsToDisplay],
  );

  return (
    <>
      <div className={styles.catalogSizeHotfilter}>
        <div className={styles.catalogSizeHotfilter__mysizesContainer}>
          <MysizesWrapper />
        </div>
        {orderedFilterGroups.map((filterGroup) => (
          <React.Fragment key={`size-filter-${filterGroup.facet}`}>
            <SizeHotfilterAccordion filterGroup={filterGroup} />
            <div className={styles.catalogSizeHotfilter__divider} />
          </React.Fragment>
        ))}
      </div>
    </>
  );
};

export default CatalogSizeHotfilter;
